import React from 'react';
import { Form, Typography } from 'antd';
import { Input, Button } from '@gamesb42/ui-kit';

const { Title, Text, Link } = Typography;

interface LoginFormData {
  login: string;
  password: string;
}

interface LoginFormProps {
  form: any;
  loading: boolean;
  onFinish: (values: LoginFormData) => void;
  onSignupClick: () => void;
  onForgotPasswordClick?: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ form, loading, onFinish, onSignupClick, onForgotPasswordClick }) => {
  return (
    <>
      <Title level={2} style={{ marginBottom: '20px', textAlign: 'left' }}>
        Sign in and <span style={{ color: '#5227cb' }}>start earning revenue</span>
      </Title>

      <div style={{ marginBottom: '32px' }}>
        <Text>
          Don't have an account yet?{' '}
          <Link
            href="#"
            style={{ color: '#5227cb', textDecoration: 'underline' }}
            onClick={(e) => {
              e.preventDefault();
              onSignupClick();
            }}
          >
            Sign up
          </Link>
        </Text>
      </div>

      <Form form={form} layout="vertical" onFinish={onFinish} size="large">
        <Form.Item
          name="login"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Please enter a valid email!' },
          ]}
        >
          <Input label="Email" placeholder="Enter your email" size="large" />
        </Form.Item>

        <Form.Item name="password" rules={[{ required: true, message: 'Please input your password!' }]}>
          <Input label="Password" placeholder="Enter your password" size="large" type="password" />
        </Form.Item>

        {onForgotPasswordClick && (
          <div style={{ textAlign: 'right', marginBottom: '4px', marginTop: '-24px' }}>
            <Link
              onClick={onForgotPasswordClick}
              style={{ color: '#5227cb', fontSize: '16px', cursor: 'pointer', textDecoration: 'underline' }}
            >
              Forgot Password?
            </Link>
          </div>
        )}

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
            violet
            style={{
              color: '#fff',
              width: '94px',
            }}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default LoginForm;
